import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=40170fbb"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=40170fbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports